import { request } from "./request";
import * as apiConstants from "../constants/Api";

export const fetchAllConnectors = () => {
  return request(
    "get",
    `${apiConstants.SERVER_URL}/apps-service/connectors/all`
  );
};

export const fetchFormBasedConnectors = () => {
  return request("get", `${apiConstants.SERVER_URL}/apps-service/connectors`);
};
